export const ENV_VARIABLE = process.env.REACT_APP_ENV_VARIABLE || 'local'
export const APP_VERSION = process.env.REACT_APP_VERSION || 'local'
